// *********************************
// 10-10-2021 - dwn:
// Added items on this date from:
// https://www.ngdevelop.tech/integrate-google-analytics-with-angular-angular-seo/
// Test this. If it doesn't work, try the updates on the same page about mid-way down
//  under "Environment Specific Google Analytics Setup with Angular"
// *********************************

import { ConfigurationService } from 'src/app/services/configuration.service';
import { Component, OnInit, AfterContentInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';                                                                // 09-01-2021 - dwn: next two lines added to support google analytics
import * as $ from 'jquery';
import { filter } from 'rxjs/operators';                                                                                // 10-10-2021 - dwn: added to support this.router.events.pipe below

declare function InitMyJs(): void;                                                                                      // fake to skip ide error

//declare let gtag: Function;                                                                                           // 09-16-2021 - dwn: updated to 'gtag' from 'ga' : 09-01-2021 - dwn: give angular access to ga function
declare const gtag: Function;                                                                                           // 10-10-2021 - dwn: changed from "declare let" to "declare const"

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})

export class AppComponent implements OnInit, AfterContentInit {

  title = 'Rankipedia';

  // 09-01-2021 - dwn: added items in constructor to support google analytics
 constructor(public router: Router) {
 // 10-10-2021 - dwn: added
  this.router.events.pipe(
    filter(event => event instanceof NavigationEnd)
      ).subscribe((event: NavigationEnd) => {
        gtag('event', 'page_view', {
            page_path: event.urlAfterRedirects
        })
  })
 // 10-10-2021 - dwn: removed
 //   this.router.events.subscribe(event => {
 //     if (event instanceof NavigationEnd) {
 //       gtag('set', 'page', event.urlAfterRedirects);
 //       gtag('send', 'pageview');
 //     }
 //   });
  }

  ngOnInit(): void {}

  ngAfterContentInit() {}

}
